import React from 'react';

import {
  Action,
  Actions,
  ActionBar,
  FileDownloadIcon,
  FileUploadIcon,
  DescriptionIcon,
  ListAltIcon,
} from '@gogame/components';
import { FullScreenToggler } from '@gogame/data-grid';
import { SearchField, useScreenTitle } from '@gogame/screens';

export default ({
  templateUpdateUpdated,
  onCreate,
  onExportSpendLog,
  onExportTemplate,
  onUploadUpdatedCampaigns,
  onUploadGGCampaigns,
  onExportUpdatedCampaigns,
  onOpenRewardPackages,
}) => {
  const [title] = useScreenTitle();

  return (
    <ActionBar
      title={title}
      search={<SearchField tooltip={'Search by name, id, GG campaign id'} />}
      secondaryActions={
        <Actions>
          <Action
            icon={<FileDownloadIcon />}
            tooltip={'Export Influencers Campaigns'}
          >
            <Action label={'Export spend log'} onClick={onExportSpendLog} />
            <Action label={'Export campaigns'} onClick={onExportTemplate} />
          </Action>

          <Action
            icon={<FileUploadIcon />}
            tooltip={'Import Influencers Campaigns'}
          >
            <Action
              label={'Import Updated Campaigns'}
              onClick={onUploadUpdatedCampaigns}
            />
            <Action
              label={'Import from GG campaigns template'}
              onClick={onUploadGGCampaigns}
            />
          </Action>
          <Action
            label={'Download template for updating campaigns'}
            onClick={onExportUpdatedCampaigns}
            icon={<DescriptionIcon />}
            tooltip={`Download template for updating campaigns${
              templateUpdateUpdated ? ' (Updated)' : ''
            }`}
            badge={templateUpdateUpdated}
          />
          <Action component={FullScreenToggler} />
          <Action
            label={'View Reward Packages'}
            onClick={onOpenRewardPackages}
            icon={<ListAltIcon />}
          />
        </Actions>
      }
      primaryActions={
        <Actions>
          <Action
            border={true}
            button={true}
            add={true}
            iconContent={true}
            tooltip={'Add Influencer Campaign'}
            variant={'outlined'}
            onClick={onCreate}
          />
        </Actions>
      }
    />
  );
};
